import React, { useEffect, useRef, useState } from "react";

import style from "./DealType.module.css";

export function DealTypeBtn(props){
    let [isOpen, setIsOpen] = useState(false);
    let containerRef = useRef();
    let [selectedType, setSelectedType] = useState(-1); //0 for sale 1 for rent

    function handleClickOutside(ev){
        if (containerRef.current && !containerRef.current.contains(ev.target)){
            setIsOpen(false)
        }
    }

    useEffect(() => {
        window.addEventListener("mousedown", handleClickOutside);

        return () => {
            window.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    /*useEffect(() => {
        props.setFunction(selectedType);
    }, [selectedType]);*/

    useEffect(() => {
        setSelectedType(props.dealType);
    }, [])

    function selectType(type){
        if (selectedType == type){
            setSelectedType(-1);
            props.setFunction(-1);
            return;
        }
        setSelectedType(type);
        props.setFunction(type);
    }

    return <div className={`${style.container}`} ref={containerRef}>
        <div className={`${style.button}`} onClick={() => {setIsOpen(!isOpen)}}>
            <div className={`${style.button_text}`}>
                {selectedType == 0? "فروش" : selectedType == 1? "رهن و اجاره" : selectedType == 2? "پیش فروش" : selectedType == 3? "مشارکت" : "نوع معامله"}
            </div>
            <div className={`${style.button_icon}`}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{width: "20px", height: "20px"}}><path d="M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"/></svg>
            </div>
        </div>
        <div className={`${style.content}`} dir="rtl" hidden={!isOpen}>
            <div className={`${style.content_item} ${selectedType == 0? style.content_item_active : ""}`} onClick={() => selectType(0)}>
                فروش
            </div>
            <div className={`${style.content_item} ${selectedType == 1? style.content_item_active : ""}`} onClick={() => selectType(1)}>
                رهن و اجاره
            </div>
            <div className={`${style.content_item} ${selectedType == 2? style.content_item_active : ""}`} onClick={() => selectType(2)}>
                پیش فروش
            </div>
            <div className={`${style.content_item} ${selectedType == 3? style.content_item_active : ""}`} onClick={() => selectType(3)}>
                مشارکت
            </div>
        </div>
    </div>
}